import { render, staticRenderFns } from "./RegisterSuccessOp.vue?vue&type=template&id=7b1bb00a&"
import script from "./RegisterSuccessOp.vue?vue&type=script&lang=js&"
export * from "./RegisterSuccessOp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports